import React from 'react'
import PropTypes from 'prop-types'

const DELETE_BUTTON_STYLE = { top: '50%', right: '10px', transform: 'translateY(-50%)' }
const NO_BACKGROUND_STYLE = { backgroundImage: 'none' }

const FileNameField = ({
  inputId, name, placeholder, fileName = '', disabled = false,
  errors = null, allowDelete = true, onDeleteClick
}) => {
  const hasError = Boolean(errors)
  const showDeleteButton = Boolean(fileName && allowDelete)
  const inputClass = `form-control bg-white${hasError ? ' is-invalid' : ''}`
  const inputStyle = hasError && showDeleteButton ? NO_BACKGROUND_STYLE : null

  return (
    <div className="position-relative flex-grow-1">
      <input
        type="text"
        id={`${inputId}-display`}
        name={`${name}-display`}
        className={inputClass}
        placeholder={placeholder}
        style={inputStyle}
        value={fileName}
        disabled={disabled}
        aria-label={placeholder}
        readOnly
      />
      {showDeleteButton ? (
        <button
          type="button"
          className="position-absolute btn btn-link text-muted p-0 hover-danger"
          style={DELETE_BUTTON_STYLE}
          disabled={disabled}
          title="Supprimer le fichier"
          onClick={onDeleteClick}
        >
          <i className="fas fa-times" />
        </button>
      ) : null}
    </div>
  )
}

FileNameField.propTypes = {
  allowDelete: PropTypes.bool,
  disabled: PropTypes.bool,
  errors: PropTypes.arrayOf(PropTypes.string),
  fileName: PropTypes.string,
  inputId: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
  onDeleteClick: PropTypes.func.isRequired,
  placeholder: PropTypes.string.isRequired
}

FileNameField.defaultProps = {
  allowDelete: true,
  disabled: false,
  errors: null,
  fileName: ''
}

export default FileNameField
